(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {


      this.header = document.querySelector('.shopify-section.section-header');
      this.announcement =  document.querySelector(".section--announcement-bar")

  
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.removeTransparentBackgroundWhenOpen()
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
      observer.observe(this.announcement);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {

   
     // this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
     this.header.classList.add('shopify-section-header-sticky')
     
     this.header.style.top = `0px`;
      this.announcement.classList.add('shopify-section-announcement-hidden', 'shopify-section-announcement-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
   //   this.header.classList.add('shopify-section-header-sticky', 'animate');
   this.header.classList.add('shopify-section-header-sticky')
      this.announcement.classList.add('shopify-section-announcement-sticky', 'animate');
      this.header.style.top = `${this.announcement.clientHeight }px`;
   //   this.header.classList.remove('shopify-section-header-hidden');
   this.announcement.classList.remove('shopify-section-announcement-hidden');
     
    }

    reset() {
      
      this.header.classList.add('shopify-section-header-sticky')
    //  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.announcement.classList.remove('shopify-section-announcement-hidden', 'shopify-section-announcement-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    removeTransparentBackgroundWhenOpen() {
      this.header.addEventListener("click", ()=> {
        const openAttributes = this.header.querySelectorAll('.header__menu-item[aria-expanded="true"]');
        if(openAttributes && openAttributes.length > 0) {
          this.header.classList.add('header-transparent--open');
          this.announcement.classList.add('header-transparent--open');
        } else {
          this.header.classList.remove('header-transparent--open');
          this.announcement.classList.remove('header-transparent--open');
        }
      })
    }
  }

  customElements.define('sticky-header', StickyHeader);

  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow-image-with-text"]) return;
  try {
    
  // <script src="https://cdn.shopify.com/s/files/1/0625/9313/8947/files/swiper-bundle.min.js?v=1690967110" defer="defer"></script>

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow-media-background"]) return;
  try {
    
  // <script src="https://cdn.shopify.com/s/files/1/0625/9313/8947/files/swiper-bundle.min.js?v=1690967110" defer="defer"></script>

  } catch(e) { console.error(e); }
})();
})();
